import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, { useState } from "react";
import { useEffect } from "react";
import {useLocation, useNavigate} from "react-router-dom";
import { ContentsSection, PageTitle } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import { LoadingBox } from "component/basic/popup";
import { FixedPage } from "component/basic";
import { NotItems } from "component/basic/notItems";
import { PointFixedTap, Tap } from "component/basic/tap";
import { FixedContents } from "component/product/page";
import { AccordionItem } from "component/basic/items";
import { PageContentsSection } from "component/mypage/items";
import {CsControll, FaqControll} from "component/board/items";

const Faq = (props) => {
    const navigate = useNavigate();
    const location = useLocation().search;

    const prams = location.split('&') ? location.split('&') : [];
    const pramPopup = prams[0] ? prams[0].split('?popup=')[1] : "";

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);

    const [viewFaq,setViewFaq] =  useState(null);
    const [category,setCategory] =  useState(null);
    const [startOpen,setStartOpen] =  useState(null);

    const categoryApi = useGet({
        url:`/faq/category`,
        loginType:"login"
    });
    const categoryData = categoryApi?.data?.faq_categories;

    const pageDataApi = useGet({
        url:`/faq${category ? `?category_id=${category}` : ""}`,
        loginType:"login"
    });
    const pageData = pageDataApi?.data?.faq;

    useEffect(() => {
        setLoadingBoxOpen(false);

        if(sessionStorage.getItem("faqOpen") || sessionStorage.getItem("faqOpen") == 0){
            setStartOpen(sessionStorage.getItem("faqOpen"));
            sessionStorage.removeItem("faqOpen");
        }
    }, []);

    return (
        <>
            <ContentsSection
                header={true}
                footer={true}
                addClass={"gBg"}
            >
                <Header
                    addClass=""
                    logo={false}
                    mMenu={false}
                    pageBack={true}
                    func={()=>{navigate(-1)}}
                    headTitle={"자주 찾는 질문"}
                    rightBtnsArr={null}
                    pageClose={false}
                    activeType={3}
                    closeFunc={()=>{}}
                />
                <FixedPage addClass="reverse mnReverse pageTitlePage">
                    <FaqControll pram={pramPopup}/>
                    <FixedContents>
                        <PageTitle
                            addClass="fixedContents_title"
                            pageBack={null}
                            contents="자주 찾는 질문"
                        >
                            <Tap
                                addClass="underLine pcItemT"
                                data={categoryData}
                                nameKey={"category"}
                                valKey={"id"}
                                nameCaption={"#"}
                                val={category}
                                allText="#전체"
                                func={(name,val)=>{setCategory(val)}}
                            />
                        </PageTitle>
                        <PointFixedTap
                            boxAddClass={"mItemT"}
                            headerTap={false}
                            headerChk={true}
                            addClass=""
                            data={categoryData}
                            allText="#전체"
                            nameCaption={"#"}
                            nameKey="category"
                            valKey="id"
                            val={category}
                            func={(name,val)=>{setCategory(val)}}
                        />
                        <PageContentsSection>
                            {pageData && pageData?.length > 0 ? 
                                <>
                                    {pageData && pageData?.map((item, i) => (
                                        <AccordionItem
                                            key={i}
                                            id={item.id}
                                            closeChk={viewFaq}
                                            questionIcon={true}
                                            startOpen={startOpen}
                                            title={item.title}
                                            subTitle={`#${item.category}`}
                                            text={item.contents}
                                            func={(id)=>{
                                                setViewFaq(id)
                                            }}
                                        />
                                    ))}
                                </>
                            :
                                <NotItems addClass="fullPage" text={`자주 찾는 질문이 없습니다.`}/>
                            }
                        </PageContentsSection>
                    </FixedContents>
                </FixedPage>
            </ContentsSection>
            <Footer/>
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default Faq;